import tw from 'tailwind-styled-components';

interface ButtonProps {
  disabled: boolean;
  onClick?: () => void;
}

const BaseButton = tw.button<ButtonProps>`
ml-3 inline-flex justify-center md:text-sm text-xs rounded-md border border-transparent py-2 px-2 md:px-4 font-medium shadow-sm
${(props) =>
  !props.disabled &&
  'bg-green-600  text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2'} 
${(props) =>
  props.disabled &&
  'bg-gray-200 text-gray-400 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-100 focus:ring-offset-2 cursor-not-allowed'} 
`;

interface Props {
  label: string;
  disabled: boolean;
  onClick?: () => void;
}

export const SubmitButton: React.FC<Props> = ({ label, disabled, onClick }) => {
  return (
    <BaseButton type="submit" disabled={disabled} onClick={onClick}>
      {label}
    </BaseButton>
  );
};
